export default class Customer {
  constructor(...dtos) {
    Object.assign(this, ...dtos);
  }
}
